import { ICreateItemFolhaPagamentoUseCase } from "../../../presentation/useCases/create/create_item_folha_pagamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateItemFolhaPagamentoUseCase
 */

export class CreateItemFolhaPagamentoUseCase implements ICreateItemFolhaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async createItemFolhaPagamento(
    idFolhaPagamento: number,
    idCentroCusto: number,
    idFuncionarios: number[],
    idFuncionarioResponsavel: number,
    dataPagamento: Date,
    idSubconta: number | null,
  ): Promise<void> {
    await this.repository.createItemFolhaPagamento(
      idFolhaPagamento,
      idCentroCusto,
      idFuncionarios,
      idFuncionarioResponsavel,
      dataPagamento,
      idSubconta,
    );
  }
}
